import { render, staticRenderFns } from "./CutDossie.vue?vue&type=template&id=3c7da136&"
import script from "./CutDossie.vue?vue&type=script&lang=js&"
export * from "./CutDossie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports